<template>
  <div class="index">
    <Headerm></Headerm>
    <hr>
    <div :class="{'main-bg': theme === 'dark'}">
      <div class="wrap">
        <div class="maincontainer">
          <el-tabs type="border-card" v-model="searchTabActiveName" class="maintenancetab">
            <el-tab-pane :label="$t('T_SIMULATOR_MAINTENANCE')" name="simulatorMain">
              <SimulatorMainTab :searchTabActiveName="searchTabActiveName"></SimulatorMainTab>
            </el-tab-pane>
            <el-tab-pane style="padding-left:0px;" :label="$t('T_PROJECTOR_SEARCH_MAINTENANCE')" name="projectSearchMainTab">
              <ProjectSearchMainTab :searchTabActiveName="searchTabActiveName"></ProjectSearchMainTab>
            </el-tab-pane>
            <el-tab-pane :label="$t('T_OPTION_LENS_DATA_MAINTENANCE')" name="lensDataMainTab">
              <LensDataMainTab :searchTabActiveName="searchTabActiveName"></LensDataMainTab>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Headerm from '../components/headerm'
import SimulatorMainTab from '../components/maintenanceTab/simulatorMainTab'
import ProjectSearchMainTab from '../components/maintenanceTab/projectSearchMainTab'
import LensDataMainTab from '../components/maintenanceTab/lensDataMainTab'
export default {
  name: 'maintenance',
  components: {
    Headerm,
    SimulatorMainTab,
    ProjectSearchMainTab,
    LensDataMainTab
  },
  props: {},
  data () {
    return {
      searchTabActiveName: 'simulatorMain'
    }
  },
  watch: {},
  computed: {
    ...mapState([
      'theme'
    ])
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/maintenance.vue